import { RootComponent } from "./components/RootComponent";
import { NotFoundComponent } from "./components/NotFoundComponent";
import { CanvasComponent } from "./components/CanvasComponent";
import { MapComponent } from "./components/MapComponent";
import { TabletComponent } from "./components/TabletComponent";
import { InventoryComponent } from "./components/InventoryComponent";
import { PanicMeterComponent } from "./components/PanicMeterComponent";

// Expose the web components to the browser
window.customElements.define("game-root", RootComponent);
window.customElements.define("game-notfound", NotFoundComponent);
window.customElements.define("game-canvas", CanvasComponent);
window.customElements.define("map-component", MapComponent);
window.customElements.define("tablet-component", TabletComponent);
window.customElements.define("inventory-component", InventoryComponent);
window.customElements.define("panic-meter-component", PanicMeterComponent);
